const matchhoroscope = {
  // Header Section
  "kundli_matching_service": "కుండ్లీ మ్యాచింగ్ సేవ",
  "match_your": "మీ",
  "horoscopes": "పెళ్లి, ప్రేమ",
  "for_perfect_union": "మరియు భవిష్యత్ నిర్ణయాలకు సరైన మార్గం రూపొందించబడుతుంది",
  "match_horoscope_description": "వాస్తవిక వేద జ్యోతిష్యంతో మీ పెళ్లి అనుకూలత తెలుసుకోండి. 36 గుణాల కుండ్లీ మ్యాచింగ్ మీ భవిష్యత్ సౌఖ్యాన్ని నిర్ధారిస్తుంది.",

  // Form Fields
  "partner_1_details": "భాగస్వామి 1 వివరాలు",
  "partner_2_details": "భాగస్వామి 2 వివరాలు",
  "male_groom": "పురుషుడు/వరుడు",
  "female_bride": "స్త్రీ/వధువు",
  "enter_groom_name": "వరుడి పూర్తి పేరును నమోదు చేయండి",
  "enter_bride_name": "వధువు పూర్తి పేరును నమోదు చేయండి",
  "full_name": "పూర్తి పేరు",
  "gender": "లింగం",
  "male": "పురుషుడు",
  "female": "స్త్రీ",
  "date_time_of_birth": "జనన తేదీ & సమయం",
  "place_of_birth": "జనన స్థలం",
  "enter_partner_name": "భాగస్వామి పేరు నమోదు చేయండి",
  "city_state_country": "నగరం, రాష్ట్రం, దేశం",
  "email_address": "ఈమెయిల్ చిరునామా",
  "phone_number": "ఫోన్ నంబర్",
  "enter_email_for_report": "వివరమైన రిపోర్ట్ కోసం మీ ఈమెయిల్ నమోదు చేయండి",
  "enter_phone": "మీ ఫోన్ నంబర్ నమోదు చేయండి",
  "contact_details_info": "సంప్రదింపు వివరాలు ఇస్తే, వివరమైన అనుకూలత రిపోర్ట్ మీకు నేరుగా అందించబడుతుంది.",
  "service_pricing": "సేవా ధర",
  "complete_horoscope_matching": "సంపూర్ణ కుండ్లీ మ్యాచింగ్ విశ్లేషణ",
  "one_time_payment_info": "నిపుణులైన జ్యోతిష్కులచే సంపూర్ణ మ్యాచింగ్ విశ్లేషణకు ఒక్కసారే చెల్లింపు",
  "detailed_compatibility_analysis": "వివరణాత్మక అనుకూలత విశ్లేషణ",
  "guna_milan_36_points": "గుణ మిలాన్ (36 పాయింట్ల విధానం)",
  "manglik_dosha_analysis": "మంగళిక్ దోష విశ్లేషణ",
  "future_predictions_couple": "మీ జీవిత భాగస్వామి కోసం భవిష్యత్ అంచనా",
  "remedial_solutions": "పరిహార సూచనలు & సిఫారసులు",
  "pdf_report_download": "PDF రిపోర్ట్ డౌన్‌లోడ్",
  "contact_information": "సంప్రదింపు సమాచారం",

  // Actions
  "match_horoscopes_now": "ఇప్పుడే కుండ్లీలు మ్యాచ్ చేయండి",
  "matching_horoscopes": "కుండ్లీ మ్యాచింగ్ జరుగుతోంది",
  "pay_and_match": "చెల్లించి కుండ్లీలు మ్యాచ్ చేయండి",
  "processing_payment": "చెల్లింపు ప్రాసెస్ జరుగుతోంది...",
  "dd_mm_yyyy_time_format": "DD/MM/YYYY మరియు HH:MM (12-గంటలు) AM/PM రూపంలో నమోదు చేయండి",
  "am": "AM",
  "pm": "PM",
  "dd_placeholder": "DD",
  "mm_placeholder": "MM",
  "yyyy_placeholder": "YYYY",
  "hh_placeholder": "HH",

  // Results
  "compatibility_result": "అనుకూలత ఫలితం",
  "overall_compatibility": "మొత్తం అనుకూలత",
  "guna_milan_points": "గుణ మిలాన్ పాయింట్లు",
  "match_status": "మ్యాచింగ్ స్థితి",
  "excellent_match": "అత్యుత్తమ మ్యాచ్",
  "good_match": "మంచి మ్యాచ్",
  "average_match": "సగటు మ్యాచ్",
  "detailed_guna_analysis": "వివరమైన గుణ విశ్లేషణ",

  // Actions
  "download_detailed_report": "వివరమైన రిపోర్ట్ డౌన్‌లోడ్ చేయండి",
  "consult_astrologer": "జ్యోతిష్కుడిని సంప్రదించండి",
  "match_another_couple": "ఇంకో జంటను మ్యాచ్ చేయండి",

  // Features
  "what_our_matching_includes": "మా మ్యాచింగ్‌లో ఏమేం ఉంటాయి",
  "36_guna_analysis": "36 గుణాల విశ్లేషణ",
  "36_guna_analysis_desc": "అన్ని 36 అనుకూలత బిందువుల సంపూర్ణ మూల్యాంకనం",
  "love_compatibility": "మీ ప్రేమ జీవితం",
  "love_compatibility_desc": "భావోద్వేగ & రొమాంటిక్ సమన్వయ విశ్లేషణ",
  "family_harmony": "కుటుంబ సౌఖ్యం",
  "family_harmony_desc": "దీర్ఘకాల సంబంధ స్థిరత్వంపై అంచనా",
  "manglik_dosha": "మంగళిక్ దోష తనిఖీ",
  "manglik_dosha_desc": "దోషాల గుర్తింపు మరియు పరిహారాలు",

  // Thank You Message
  "thank_you_submission": "మీ సమర్పణకు ధన్యవాదాలు!",
  "data_received_message": "మీ కుండ్లీ మ్యాచింగ్ అభ్యర్థనను విజయవంతంగా స్వీకరించాం. మా అనుభవజ్ఞులైన జ్యోతిష్కులు రెండు జాతకాలను జాగ్రత్తగా విశ్లేషిస్తారు.",

  // Security & Timeline
  "your_data_secure": "మీ డేటా 100% సురక్షితం",
  "data_security_message": "అన్ని వ్యక్తిగత సమాచారం ఎన్‌క్రిప్ట్ చేసి రక్షించబడింది. మీ వివరాలను మేమెప్పుడూ మూడవ పక్షాలతో పంచము.",
  "response_within_12_hours": "12 గంటల్లో స్పందన",
  "response_time_message": "మా నిపుణులు మీ వివరమైన అనుకూలత రిపోర్ట్ సిద్ధం చేసి త్వరలోనే సంప్రదిస్తారు.",

  // Support
  "need_immediate_help": "తక్షణ సహాయం కావాలా?",
  "whatsapp_support": "వాట్సాప్ సపోర్ట్",
  "processing_request": "మీ అభ్యర్థన ప్రాసెస్‌లో ఉంది",
  "back_to_home": "హోమ్‌కి తిరిగి వెళ్ళండి"
};

export default matchhoroscope;
